import { render, staticRenderFns } from "./formularios-declaracoes.vue?vue&type=template&id=5ee8ba7a&scoped=true"
import script from "./formularios-declaracoes.vue?vue&type=script&lang=js"
export * from "./formularios-declaracoes.vue?vue&type=script&lang=js"
import style0 from "./formularios-declaracoes.vue?vue&type=style&index=0&id=5ee8ba7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ee8ba7a",
  null
  
)

export default component.exports